import { render } from "./FinanceClaimsComponent.vue?vue&type=template&id=056f83f9&scoped=true"
import script from "./FinanceClaimsComponent.vue?vue&type=script&lang=js"
export * from "./FinanceClaimsComponent.vue?vue&type=script&lang=js"

import "./FinanceClaimsComponent.vue?vue&type=style&index=0&id=056f83f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056f83f9"]])

export default __exports__